import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Router, browserHistory, applyRouterMiddleware } from 'react-router'
import { applyMiddleware, createStore, compose, combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import {
  syncHistoryWithStore,
  routerMiddleware,
  routerReducer,
} from 'react-router-redux'
import { useScroll } from 'react-router-scroll'
import {
  reactReduxFirebase,
  firebaseStateReducer as firebaseReducer,
  getFirebase,
} from 'react-redux-firebase'
import thunkMiddleware from 'redux-thunk'
import * as firebase from 'firebase'
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import { createTracker } from 'redux-segment'
import segmentMiddleware from './reduxSegment'

import registerServiceWorker from './registerServiceWorker'
import routes from './routes'
import * as locales from './locales'

addLocaleData([...en])

const language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0]
const messages =
  locales[languageWithoutRegionCode] || locales[language] || locales.en

const tracker = createTracker()

const reducers = {
  routing: routerReducer,
  form: formReducer,
  firebase: firebaseReducer,
}

const middlewares = [
  thunkMiddleware.withExtraArgument(getFirebase),
  segmentMiddleware,
  routerMiddleware(browserHistory),
  tracker,
]

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
}

firebase.initializeApp(firebaseConfig)

const storeEnhancer = compose(
  applyMiddleware(...middlewares),
  reactReduxFirebase(firebase, {
    userProfile: 'users',
    profileParamsToPopulate: [
      'purchases:purchases',
      'types:userTypes',
      'payments:payments',
      'tranches:tranches',
    ],
  }),
  window.devToolsExtension ? window.devToolsExtension() : f => f
)

const routerEnhancer = applyRouterMiddleware(useScroll())

const reducer = combineReducers(reducers)
const store = createStore(reducer, storeEnhancer)
const history = syncHistoryWithStore(browserHistory, store)

class App extends React.Component {
  componentDidMount() {
    window.analytics.load(process.env.REACT_APP_SEGMENT_API_KEY)

    if (process.env.REACT_APP_RAYGUN_API_KEY && window.rg4js) {
      window.rg4js('apiKey', process.env.REACT_APP_RAYGUN_API_KEY)
      window.rg4js('enableCrashReporting', true)
    }
  }

  render() {
    return (
      <IntlProvider locale={language} messages={messages}>
        <Provider store={store}>
          <Router history={history} routes={routes} render={routerEnhancer} />
        </Provider>
      </IntlProvider>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js